import React from 'react';
import { Search, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const CITIES = ['Beverly Hills', 'Aspen', 'Miami Beach', 'Manhattan'];
export function Hero() {
  return <section className="relative w-full bg-stone-50 overflow-hidden" data-id="element-42">
      <div className="max-w-6xl mx-auto px-6 md:px-12 pt-36 pb-24 flex flex-col items-center" data-id="element-43">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center max-w-3xl mb-12" data-id="element-44">
          <span className="block text-charcoal-500 uppercase tracking-[0.2em] text-xs font-medium mb-5" data-id="element-45">
            The New Standard of Luxury
          </span>
          <h1 className="text-4xl md:text-6xl font-light text-charcoal-900 tracking-tight leading-[1.1]" data-id="element-46">
            Discover extraordinary <br className="hidden md:block" data-id="element-47" />
            estates worldwide.
          </h1>
        </motion.div>

        {/* Framed Image */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full max-w-4xl bg-white border border-stone-200 rounded-[2rem] p-4 md:p-6 shadow-sm" data-id="element-48">
          <div className="aspect-[16/9] w-full overflow-hidden rounded-3xl bg-stone-100" data-id="element-49">
            <img src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=80" alt="Serene, light-filled luxury living space" className="w-full h-full object-cover" data-id="element-50" />
          </div>
        </motion.div>

        {/* Search — overlapping the bottom edge of the frame */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative z-10 w-full max-w-2xl -mt-8 md:-mt-10" data-id="element-51">
          <div className="bg-white border border-stone-200 rounded-2xl p-2 shadow-[0_8px_30px_rgba(0,0,0,0.08)] flex items-center gap-2" data-id="element-52">
            <div className="flex-1 flex items-center px-4 h-12 md:h-14" data-id="element-53">
              <MapPin size={20} className="text-charcoal-400 mr-3 shrink-0" data-id="element-54" />
              <input type="text" placeholder="Search by city, neighborhood, or zip..." className="w-full bg-transparent border-none outline-none text-charcoal-900 placeholder:text-charcoal-300 text-base md:text-lg" data-id="element-55" />
            </div>
            <button className="flex items-center justify-center gap-2 px-6 md:px-8 h-12 md:h-14 bg-charcoal-900 text-white rounded-xl hover:bg-charcoal-800 transition-colors font-medium" data-id="element-56">
              <Search size={18} data-id="element-57" />
              <span className="hidden sm:inline" data-id="element-58">Search</span>
            </button>
          </div>

          {/* City chips */}
          <div className="mt-6 flex flex-wrap justify-center gap-3" data-id="element-59">
            {CITIES.map(city => <button key={city} className="px-4 py-2 rounded-full bg-stone-100 border border-stone-200 text-charcoal-600 text-sm hover:bg-stone-200/70 hover:border-stone-300 transition-colors" data-id="element-60">
                {city}
              </button>)}
          </div>
        </motion.div>
      </div>
    </section>;
}